import { TemplatesService } from '../../../services';
// import * as monaco from "monaco-editor/min/vs/editor/editor.main.js";


class TemplatesEditorController {
    editorContent: any;
    currentTemplateName: string;
    private sweetAlert: any;

    constructor(private TemplatesService: TemplatesService,
                private SweetAlert: any) {
        "ngInject";
        this.sweetAlert = SweetAlert;
    }

    $onInit = () => {
        // monaco.editor.create(document.getElementById("container"), {
        //     value: "function hello() {\n\talert('Hello world!');\n}",
        //     language: "javascript"
        // });

        // console.log('TemplatesEditorController init');
     
        var onGotAmdLoader = () => {
            // Load monaco
            (<any>window).require.config({ paths: { 'vs': '/vs' }});
            (<any>window).require(['vs/editor/editor.main'], () => {
                this.initMonaco();
                
            });
        };

        // Load AMD loader if necessary
        if (!(<any>window).require) {
            var loaderScript = document.createElement('script');
            loaderScript.type = 'text/javascript';
            loaderScript.src = '/vs/loader.js';
            loaderScript.addEventListener('load', onGotAmdLoader);
            document.body.appendChild(loaderScript);
        } else {
            onGotAmdLoader();
        }
    }

    // Will be called once monaco library is available
    initMonaco() {
        (<any>window).editor = (<any>window).monaco.editor.create(document.getElementById("container"), {
            value: '',
            language: 'razor'
        });
        
        
    }

    getTemplate() {
        this.TemplatesService.customGet('template/' + this.currentTemplateName).then((result) => {
            (<any>window).editor.setValue(result);
        });
    }

    saveTemplate() {
        var value = (<any>window).editor.getValue();
        // console.log(value);

        this.TemplatesService.customPut('template/' + this.currentTemplateName, '"' + value.replace(/[\\"']/g, '\\$&') + '"').then(()=> {
            this.sweetAlert.swal('Updated!', 'Template has been succesfully updated!', 'success');
        });
    }
}


export const templatesEditorComponent = {
    bindings: {
        templatesNames: "<"
    },
    controller: TemplatesEditorController,
    template: require("./templatesEditor.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/templates/templatesEditor.component.ts